export const name = '$gzFields';

/**
 * @ngdoc service
 * @name gazelle.components.fields.service:$gzFields
 *
 * @description
 * The $gzFields service provides helpers to use with field definitions provided to a grid so rendering could occur elsewhere
 *
 */

export default function $gzFields(
  $translate,
  $sanitize,
  moment
) {
  //noinspection BadExpressionStatementJS
  'ngInject';
  let vm = this;


  var unitTest = {
  };

  var service = {
    resolveString: resolveString,
    getValue: getValue,
    getExportValue: getExportValue,
    getDateStringValue: getDateStringValue,
    getMappedStringValue: getMappedStringValue,
    unitTest: unitTest
  };

  activate();
  return service;

  function activate() {
  }

  //
  // Public functions
  //
  function resolveString(src, target, value = undefined) {
    if (target && target !== '') {
      // If target already has a value we will use that
      let passedIn = _.get(src, target);
      if (passedIn) {
        return passedIn;
      }
    }
    else {
      target = '';
    }

    // 2. Localization Key (example target='title', lookup 'titleKey')
    let key = _.get(src, target+'Key');
    if (key) {
      return $translate.instant(key, '!' + key + '!');
    }

    // 3. Localization Pattern (E.G. target='title', lookup 'titleKeyBase')
    let keyBase = _.get(src, target+'KeyBase');
    if (keyBase) {
      return $translate.instant(keyBase+value, '!' + 'keyBase' + value + '!');
    }

    // 4. Fall back to placeholder (id or value)
    return value;
  }

  function getValue(rawValue, data, column, params) {
    let myValue = rawValue;
    let valueRenderer = _.get(column, 'field.callbacks.valueRenderer');
    if (valueRenderer) {
      let customValue = valueRenderer(rawValue, data, column, params);
      if (column.type === 'custom') {
        return customValue === undefined ? null : customValue;
      }
      else {
        myValue = customValue;
      }
    }

    switch (column.type) {
      case 'string':
        myValue = getStringValue(myValue, column);
        if (myValue) {
          myValue = '' + myValue;
          myValue = myValue.replace(/{{/g, '');
          myValue = myValue.replace(/}}/g, '');
        }
        break;
      case 'number':
        myValue =  getNumberValue(myValue, column);
        break;
      case 'date':
        myValue =  getDateValue(myValue, column);
        break;
      case 'mapped':
        myValue =  getMappedValue(myValue, column);
        break;
      case 'duration':
        myValue =  getDurationValue(myValue, column);
        break;
      case 'image':
        myValue =  getImageValue(myValue, column);
        break;
    }

    return  myValue;
  }

  function getExportValue(rawValue, data, column) {
    let myValue = rawValue;
    let exportRenderer = _.get(column, 'field.callbacks.exportRenderer');
    if (exportRenderer) {
      let value = exportRenderer(rawValue, data, column);
      return value === undefined ? null : value;
    }

    let valueRenderer = _.get(column, 'field.callbacks.valueRenderer');
    if (valueRenderer) {
      let customValue = valueRenderer(rawValue, data, column);
      if (column.type === 'custom') {
        return customValue === undefined ? null : customValue;
      }
      else {
        myValue = customValue;
      }
    }

    switch (column.type) {
      case 'string':
        return getStringValue(myValue, column);
      case 'number':
        return getNumberValue(myValue, column);
      case 'date':
        let myDateColumn = _.cloneDeep(column);
        if (_.get(myDateColumn, 'field.date.display') === 'elapse') {
          _.set(myDateColumn, 'field.date.display', 'medium');
        }
        return getDateValue(myValue, myDateColumn);
      case 'mapped':
        let myMappedColumn = _.cloneDeep(column);
        _.set(myMappedColumn, 'field.mapped.showImage', false);
        _.set(myMappedColumn, 'field.mapped.showText', true);
        _.set(myMappedColumn, 'field.mapped.sparseValues', []);
        return getMappedValue(myValue, myMappedColumn, true);
      case 'duration':
        return getDurationValue(myValue, column);
      case 'image':
        return myValue;
    }
  }

  //
  // Private functions
  //
  function getStringValue(rawValue, column) {
    let value = null;
    if (!isEmpty(rawValue)) {
      let test = '' + rawValue;
      let display = _.get(column, 'field.string.display', undefined);
      switch (display) {
        case 'upper':
          value = test.toLocaleUpperCase();
          break;
        case 'lower':
          value =  test.toLocaleLowerCase();
          break;
        case 'lookup':
          value = $translate.instant(test, test);
          break;
        default:
          value = test;
      }
    }

    return value;
  }

  function getNumberValue(rawValue, column) {
    if (typeof(rawValue) === 'string') {
      rawValue = parseFloat(rawValue);
    }

    let value = null;
    if (!isEmpty(rawValue)) {
      let display = _.get(column, 'field.number.display', undefined);
      switch (display) {
        case 'decimal':
          let decimalPlaces = _.get(column, 'field.number.decimalPlaces', 2);
          value = Number(Math.round(rawValue + 'e' + decimalPlaces) + 'e-' + decimalPlaces);
          //value = value.toFixed(decimalPlaces);
          break;
        default:
          value = rawValue;
      }
    }

    let unitsKey = _.get(column, 'field.number.unitsKey');
    let unitKey = _.get(column, 'field.number.unitKey');
    if (value && unitsKey && unitKey) {
      let units = $translate.instant(unitsKey);
      let unit = $translate.instant(unitKey);
      if (value === 1) {
        value = `${value} ${unit}`;
      }
      else {
        value = `${value} ${units}`;
      }
    }
    return value;
  }

  function getDateValue(rawValue, column) {
    let value = null;
    if (!isEmpty(rawValue)) {
      let display = _.get(column, 'field.date.display', 'medium');
      let showTime = _.get(column, 'field.date.showTime', true);
      let showDate = _.get(column, 'field.date.showDate', true);
      if (display === 'elapse') {
        value = `<div am-time-ago="gzValue.${column.id}"><md-tooltip>{{::gzValue.${column.id} | amDateFormat: 'LLL'}}</md-tooltip></div>`;
      }
      else if (display === 'elapseOnly') {
        value = moment(rawValue).fromNow(true);
      }
      else {
        if (showDate || showTime) {
          let format;
          switch (display) {
            case 'medium':
              format = 'LLL';
              if (showDate && !showTime) {
                format = 'LL';
              }
              else if (!showDate && showTime) {
                format = 'LT';
              }
              value = moment(rawValue).format(format);
              break;
            case 'full':
              format = 'LLLL';
              if (showDate && !showTime) {
                format = 'LL';
              }
              else if (!showDate && showTime) {
                format = 'LTS';
              }
              value = moment(rawValue).format(format);
              break;
            case 'short':
              format = 'L LT';
              if (showDate && !showTime) {
                format = 'L';
              }
              else if (!showDate && showTime) {
                format = 'LT';
              }
              value = moment(rawValue).format(format);
              break;
            case 'format':
              format = _.get(column, 'field.date.format', 'LLL');
              value = moment(rawValue).format(format);
              break;
            default:
              value = moment(rawValue).format('LLL');
              break;
          }
        }
      }
    }

    return value;
  }

  function getDateStringValue(rawValue, column) {
    let columnCopy = column ? _.cloneDeep(column) : {};
    if (_.get(columnCopy, 'field.date.display') === 'elapse') {
      _.set(columnCopy, 'field.date.display', 'elapseOnly');
    }

    return getDateValue(rawValue, columnCopy);
  }

  function getMappedStringValue(rawValue, column) {
    let columnCopy = column ? _.cloneDeep(column) : {};
    _.set(columnCopy, 'field.mapped.showImage', false);
    _.set(columnCopy, 'field.mapped.showText', true);

    return getMappedValue(rawValue, columnCopy);
  }

  function getMappedValue(rawValue, column, isExport = false) {
    let value = null;
    let sparseValues = _.get(column, 'field.mapped.sparseValues', []);
    if (!isEmpty(rawValue) && !isSparseValue(rawValue, sparseValues)) {
      let display = _.get(column, 'field.mapped.display', 'raw');
      let showText = _.get(column, 'field.mapped.showText', false);
      let showBoth = _.get(column, 'field.mapped.showBoth', false);
      let iconSize = _.get(column, 'field.mapped.defaultSize', 16);

      switch (display) {
        case 'active':
        case 'on':
        case 'true':
        case 'yes':
        case 'locked':
          let test = ensureBoolean(rawValue);
          if (showText) {
            if (!isExport) {
              value = '<div gz-auto-tooltip>';
              value += getMappedString(display, test);
              value += '</div>';
            }
            else {
              value = getMappedString(display, test);
            }
          }
          else if (showBoth) {
            value = '<div layout="row" layout-align="start center">';
            value += getMappedImage(display, test, true, iconSize);
            value += '<div gz-auto-tooltip>';
            value += getMappedString(display, test);
            value += '</div>';
            value += '</div>';
          }
          else {
            value = getMappedImage(display, test, false, iconSize);
          }
          break;
        case 'status':
          value = '';
          let addStyle = ' style="font-size:'+iconSize + 'px;"';

          switch (rawValue.toUpperCase()) {
            case 'OK':
              if (showText) {
                if (!isExport) {
                  value = '<div gz-auto-tooltip>';
                  value += $translate.instant('uxf.uxf.Grid_Ok');
                  value += '</div>';
                }
                else {
                  value = $translate.instant('uxf.uxf.Grid_Ok');
                }
              }
              else if (showBoth) {
                value = '<div layout="row" layout-align="start center">';
                value += '<md-icon md-svg-src="gazelle/grid/images/ok.svg" class="gz-status-ok gz-image-spacer" ' + addStyle + '><md-tooltip>'+ $translate.instant('uxf.uxf.Grid_Ok') + '</md-tooltip></i>';
                value += '<div gz-auto-tooltip>';
                value += $translate.instant('uxf.uxf.Grid_Ok');
                value += '</div>';
                value += '</div>';
              }
              else {
                value = '<md-icon md-svg-src="gazelle/grid/images/ok.svg" class="gz-status-ok" ' + addStyle + '><md-tooltip>'+ $translate.instant('uxf.uxf.Grid_Ok') + '</md-tooltip></i>';
              }
              break;
            case 'WARN':
              if (showText) {
                if (!isExport) {
                  value = '<div gz-auto-tooltip>';
                  value += $translate.instant('uxf.uxf.Grid_Warn');
                  value += '</div>';
                }
                else {
                  value = $translate.instant('uxf.uxf.Grid_Warn');
                }
              }
              else if (showBoth) {
                value = '<div layout="row" layout-align="start center">';
                value += '<md-icon md-svg-src="gazelle/grid/images/warning.svg" class="gz-status-warn gz-image-spacer" ' + addStyle + '><md-tooltip>'+ $translate.instant('uxf.uxf.Grid_Warn') + '</md-tooltip></md-icon>';
                value += '<div gz-auto-tooltip>';
                value += $translate.instant('uxf.uxf.Grid_Warn');
                value += '</div>';
                value += '</div>';
              }
              else {
                value = '<md-icon md-svg-src="gazelle/grid/images/warning.svg"  class="gz-status-warn" ' + addStyle + '><md-tooltip>'+ $translate.instant('uxf.uxf.Grid_Warn') + '</md-tooltip></md-icon>';
              }
              break;
            case 'ERROR':
              if (showText) {
                if (!isExport) {
                  value = '<div gz-auto-tooltip>';
                  value += $translate.instant('uxf.uxf.Grid_Error');
                  value += '</div>';
                }
                else {
                  value = $translate.instant('uxf.uxf.Grid_Error');
                }
              }
              else if (showBoth) {
                value = '<div layout="row" layout-align="start center">';
                value += '<md-icon md-svg-src="gazelle/grid/images/error.svg"  class="gz-status-error gz-image-spacer" ' + addStyle + '><md-tooltip>'+ $translate.instant('uxf.uxf.Grid_Error') + '</md-tooltip></i>';
                value += '<div gz-auto-tooltip>';
                value += $translate.instant('uxf.uxf.Grid_Error');
                value += '</div>';
                value += '</div>';
              }
              else {
                value = '<md-icon md-svg-src="gazelle/grid/images/error.svg" class="gz-status-error" ' + addStyle + '><md-tooltip>'+ $translate.instant('uxf.uxf.Grid_Error') + '</md-tooltip></i>';
              }
              break;
            case 'INFO':
              if (showText) {
                if (!isExport) {
                  value = '<div gz-auto-tooltip>';
                  value += $translate.instant('uxf.uxf.Grid_Info');
                  value += '</div>';
                }
                else {
                  value = $translate.instant('uxf.uxf.Grid_Info');
                }
              }
              else if (showBoth) {
                value = '<div layout="row" layout-align="start center">';
                value += '<md-icon md-svg-src="gazelle/grid/images/info.svg" class="gz-status-info gz-image-spacer" ' + addStyle + '><md-tooltip>'+ $translate.instant('uxf.uxf.Grid_Info') + '</md-tooltip></i>';
                value += '<div gz-auto-tooltip>';
                value += $translate.instant('uxf.uxf.Grid_Info');
                value += '</div>';
                value += '</div>';
              }
              else {
                value = '<md-icon md-svg-src="gazelle/grid/images/info.svg" class="gz-status-info" ' + addStyle + '><md-tooltip>'+ $translate.instant('uxf.uxf.Grid_Info') + '</md-tooltip></i>';
              }
              break;
            case 'UNKNOWN':
              if (showText) {
                if (!isExport) {
                  value = '<div gz-auto-tooltip>';
                  value += $translate.instant('uxf.uxf.Grid_Unknown');
                  value += '</div>';
                }
                else {
                  value = $translate.instant('uxf.uxf.Grid_Unknown');
                }
              }
              else if (showBoth) {
                value = '<div layout="row" layout-align="start center">';
                value += '<md-icon md-svg-src="gazelle/grid/images/unknown.svg" class="gz-status-info gz-image-spacer" ' + addStyle + '><md-tooltip>'+ $translate.instant('uxf.uxf.Grid_Unknown') + '</md-tooltip></i>';
                value += '<div>';
                value += $translate.instant('uxf.uxf.Grid_Unknown');
                value += '</div>';
                value += '</div>';
              }
              else {
                value = '<md-icon md-svg-src="gazelle/grid/images/unknown.svg" class="gz-status-info" ' + addStyle + '><md-tooltip>'+ $translate.instant('uxf.uxf.Grid_Unknown') + '</md-tooltip></i>';
              }
              break;
          }
          break;
        case 'lookup':
          value = '';
          let lookup = _.get(column, 'field.mapped.lookup');
          if (lookup) {
            let imageBase = _.get(lookup, 'imageBase');
            let imageType = _.get(lookup, 'imageType');
            let imageColor = _.get(lookup, 'imageColor');
            let imageWidth = _.get(lookup, 'imageWidth');
            let imageHeight = _.get(lookup, 'imageHeight');
            let classes = _.get(lookup, 'classes', []);
            if (isExport) {
              classes = [];
            }
            let imageClasses = _.get(lookup, 'imageClasses', []);
            let text = resolveString(lookup, 'title', rawValue);
            let tooltip = resolveString(lookup, 'tooltip', text);

            if (showText) {
              if (classes.length > 0) {
                value = getClassesDiv(classes, isExport) + text + '</div>';
              }
              else {
                if (!isExport) {
                  value = '<div gz-auto-tooltip>';
                }
                value += text;
                if (!isExport) {
                  value += '</div>';
                }
              }
            }
            else if (showBoth) {
              let image = $translate.instant(imageBase + rawValue);
              value = '<div layout="row" layout-align="start center">';
              value += composeImageHTML(image, imageType, imageColor, imageWidth, imageHeight, imageClasses, true, tooltip);
              value += '<div flex gz-auto-tooltip>' + text + '</div>';
              value += '</div>';
            }
            else {
              let image = $translate.instant(imageBase + rawValue);
              value = composeImageHTML(image, imageType, imageColor, imageWidth, imageHeight, imageClasses, false, tooltip);
            }
          }
          break;
        case 'values':
          value = '';
          let values = _.get(column, 'field.mapped.values', undefined);
          if (values) {
            let info = _.find(values, {value: rawValue});
            if (info) {
              let image = _.get(info, 'image', undefined);
              let imageType = _.get(info, 'imageType', undefined);
              let imageColor = _.get(info, 'imageColor', undefined);
              let imageWidth = _.get(info, 'imageWidth', undefined);
              let imageHeight = _.get(info, 'imageHeight', undefined);
              let classes = _.get(info, 'classes', []);
              if (isExport) {
                classes = [];
              }
              let imageClasses = _.get(info, 'imageClasses', []);
              let text = resolveString(info, 'title', rawValue);
              let tooltip = resolveString(info, 'tooltip', text);
              if (showText) {
                if (classes.length > 0) {
                  value = getClassesDiv(classes, isExport);
                  value += text;
                  value += '</div>';
                }
                else {
                  if (isExport) {
                    value += text;
                  }
                  else {
                    value = '<div gz-auto-tooltip>';
                    value += text;
                    value += '</div>';
                  }
                }
              }
              else if (showBoth) {
                value = '<div layout="row" layout-align="start center">';
                value += composeImageHTML(image, imageType, imageColor, imageWidth, imageHeight, imageClasses, true, tooltip);
                if (classes.length > 0) {
                  value += getClassesDiv(classes) + text + '</div>';
                }
                else {
                  value += '<div flex gz-auto-tooltip>' + text + '</div>';
                }
                value += '</div>';

              }
              else {
                value = composeImageHTML(image, imageType, imageColor, imageWidth, imageHeight, imageClasses, false, tooltip);
              }
            }
            else {
              value = rawValue;
            }
          }
          break;
        default:
          value = rawValue;
          break;
      }
    }

    return value;
  }

  function getDurationValue(rawValue, column) {
    let value = null;
    if (!isEmpty(rawValue)) {
      let display = _.get(column, 'field.duration.display', 'verbose');
      let dropZero = _.get(column, 'field.duration.dropZero', false);
      let precision = _.get(column, 'field.duration.precision', 'ms');
      let significantValues = _.get(column, 'field.duration.maxUnits', 2);
      if (significantValues > 4) {
        significantValues = 4;
      }

      let s_ms_adjustment = 1;
      if (precision === 's') {
        s_ms_adjustment = 1000;
      }

      let x = rawValue * s_ms_adjustment;
      x = Math.floor(x / 1000);
      let seconds = x % 60;
      x = Math.floor(x / 60);
      let minutes = x % 60;
      x = Math.floor(x / 60);
      let hours = x % 24;
      x = Math.floor(x / 24);
      let days = x;

      let significant = false;
      let itemsPlaced = 0;
      let values = [];
      let parts = [];

      if (days > 0) {
        significant = true;
        itemsPlaced++;
        if (itemsPlaced === significantValues) {
          // Round up if last place
          if (hours > 11) {
            days++;
          }
        }
        if (days === 1) {
          parts.push('d');
        }
        else {
          parts.push('ds');
        }
        values.push(days);
      }

      if (hours > 0 || significant) {
        significant = true;
        itemsPlaced++;
        if (itemsPlaced === significantValues) {
          // Round up if last place
          if (minutes > 29) {
            hours++;
          }
        }

        if (itemsPlaced <= significantValues) {
          if (hours === 1) {
            parts.push('h');
            values.push(hours);
          }
          else if ((hours === 0 && !dropZero) || hours > 1) {
            parts.push('hs');
            values.push(hours);
          }
        }
      }

      if (minutes > 0 || significant) {
        significant = true;
        itemsPlaced++;
        if (itemsPlaced === significantValues) {
          // Round up if last place
          if (seconds > 29) {
            minutes++;
          }
        }

        if (itemsPlaced <= significantValues) {
          if (minutes === 1) {
            parts.push('m');
            values.push(minutes);
          }
          else if ((minutes === 0 && !dropZero) || minutes > 1) {
            parts.push('ms');
            values.push(minutes);
          }
        }
      }

      if (seconds > 0 || significant) {
        significant = true;
        itemsPlaced++;
        if (itemsPlaced <= significantValues) {
          if (seconds === 1) {
            parts.push('s');
            values.push(seconds);
          }
          else if ((seconds === 0 && !dropZero) || seconds > 1) {
            parts.push('ss');
            values.push(seconds);
          }
        }
      }

      if (!significant && rawValue === 0) {
        parts.push('ss');
        values.push(rawValue);
        significant = true;
      }

      if (significant) {
        let key = 'uxf.uxf.Grid_Duration';
        _.forEach(parts, part => {
          key += '_' + part;
        });

        if (display === 'medium') {
          key += '_Medium';
        }
        else if (display === 'short') {
          key += '_Short';
        }

        value = $translate.instant(key, values);
      }
    }

    return value;
  }

  function getImageValue(rawValue, column) {
    let value = null;
    if (!isEmpty(rawValue)) {
      let options = _.get(column, 'field.image');
      let type = _.get(options, 'type');
      let color = _.get(options, 'color');
      let width = _.get(options, 'width');
      let height = _.get(options, 'height');
      let imageClasses = _.get(options, 'imageClasses');
      let tooltip = resolveString(options, 'tooltip');

      value = composeImageHTML(rawValue, type, color, width, height, imageClasses, false, tooltip);
    }

    return value;
  }

  function getCustomValue(rawValue, data, column) {
    let value = null;
    if (!isEmpty(rawValue)) {

    }

    return value;
  }

  function isEmpty(value) {
    return (value === undefined || value === null || value === '');
  }

  function isSparseValue(value, sparseValues) {
    let sparse = false;
    if (sparseValues.length > 0 && _.indexOf(sparseValues, value) > -1) {
      sparse = true;
    }

    return sparse;
  }

  function getClassesDiv(classes, isExport = false) {
    let div;
    if (isExport) {
      div = '<div ';
    }
    else {
      div = '<div gz-auto-tooltip ';
    }

    if (classes && classes.length > 0) {
      div += ' class="';
      for (let i = 0; i < classes.length; i++) {
        div += classes[i];
        if (i +1 < classes.length) {
          div += ' ';
        }
      }
    }

    div += '">';

    return div;
  }

  function ensureBoolean(value) {
    if (typeof(value) === 'string') {
      value = value.toLowerCase();
    }

    return (value === 'true' || value === true) ? true : false;
  }

  function getMappedImage(type, value, withText = false, iconSize = 16) {
    let image;
    let addClass = withText ? ' gz-image-spacer' : '';
    let addStyle = ' style="font-size:'+iconSize + 'px;"';

    switch (type) {
      case 'active':
      case 'on':
      case 'true':
      case 'yes':
        image = value ? '<md-icon md-svg-src="gazelle/grid/images/ok.svg" class="gz-status-ok'+addClass+'" ' + addStyle + '><md-tooltip>' + getMappedString(type, value) +  '</md-tooltip></md-icon>' : '<md-icon  md-svg-src="gazelle/grid/images/aborted.svg" class="gz-status-error'+addClass+'" ' + addStyle + '><md-tooltip>' + getMappedString(type, value) +  '</md-tooltip></md-icon>';
        break;
      case 'locked':
        image = value ? '<i class="fa fa-lock gz-status-error'+addClass+'" ' + addStyle + '><md-tooltip>' + getMappedString(type, value) +  '</md-tooltip></i>': '<i class="fa fa-unlock gz-status-ok'+addClass+'" ' + addStyle + '><md-tooltip>' + getMappedString(type, value) +  '</md-tooltip></i>';
        break;
      default:
        image = value ? '<md-icon md-svg-src="gazelle/grid/images/ok.svg" class="gz-status-ok'+addClass+'" ' + addStyle + '><md-tooltip>' + getMappedString(type, value) +  '</md-tooltip></md-icon>' : '<md-icon md-svg-src="gazelle/grid/images/aborted.svg" class="gz-status-error'+addClass+'" ' + addStyle + '><md-tooltip>' + getMappedString(type, value) +  '</md-tooltip></md-icon>';
        break;
    }

    return image;
  }

  function getMappedString(type, value) {
    let text;
    switch (type) {
      case 'active':
        text = value ? $translate.instant('uxf.uxf.Grid_Active') :  $translate.instant('uxf.uxf.Grid_Inactive');
        break;
      case 'on':
        text = value ? $translate.instant('uxf.uxf.Grid_On') :  $translate.instant('uxf.uxf.Grid_Off');
        break;
      case 'true':
        text = value ? $translate.instant('uxf.uxf.Grid_True') :  $translate.instant('uxf.uxf.Grid_False');
        break;
      case 'yes':
        text = value ? $translate.instant('uxf.uxf.Grid_Yes') :  $translate.instant('uxf.uxf.Grid_No');
        break;
      case 'locked':
        text = value ? $translate.instant('uxf.uxf.Grid_Locked') :  $translate.instant('uxf.uxf.Grid_Unlocked');
        break;
      default:
        text = value ? $translate.instant('uxf.uxf.Grid_Yes') :  $translate.instant('uxf.uxf.Grid_No');
        break;
    }

    return text;
  }

  function composeImageHTML(image, imageType, imageColor, imageWidth, imageHeight, classes, withText = false, tooltip = undefined) {
    let addClass = withText ? 'gz-image-spacer ' : 'gz-image-cell';
    if (classes) {
      _.forEach(classes, myClass => {
        addClass += myClass + ' ';
      });
    }

    let html = '<div class="'+addClass+'">';
    let style;
    if (imageWidth || imageHeight || imageColor) {
      style = '';
      style += ' style="';

      if (imageWidth) {
        style += 'width:'+imageWidth+'px;';
        style += 'min-width:'+imageWidth+'px;';
      }
      else {
        style += 'width: auto;';
      }

      if (imageHeight) {
        style += 'height:'+imageHeight+'px;';
        style += 'min-height:'+imageHeight+'px;';
      }
      else {
        style += 'height: auto;';
      }

      if (imageColor) {
        style += 'color:'+imageColor+';';
      }

      if (imageType === 'fa' || imageType === 'md' || imageType === 'svg') {
        let fontSize = imageHeight;
        if (!imageHeight) {
          fontSize = 16;
        }
        style += 'font-size:'+fontSize+'px;';
        style += 'line-height:'+fontSize+'px;';
      }
      style += '"';
    }

    if (tooltip) {
      html += '<md-tooltip>' + tooltip + '</md-tooltip>';
    }

    html += '<div class="gz-image-container"';

    if (imageType === 'md' || imageType === 'svg') {
      if (imageHeight) {
        html += ' style="height:' + imageHeight + 'px;"';
      }
    }
    else {
      if (style) {
        html += ' ' + style;
      }
    }

    html += '>';

    switch (imageType) {
      case 'fa':
        html += '<i class="fa fa-' + image + '"></i>';
        break;
      case 'md':
        html += '<md-icon';
        if (style) {
          html += ' ' + style;
        }
        html += ' md-font-set="material-icons">' + image + '</md-icon>';
        break;
      case 'gz':
        html += '<img gz-img-src="' + image + '">';
        break;
      case 'ng':
        html += '<img ng-src="' + image + '">';
        break;
      case 'svg':
        html += '<md-icon class="gz-app-icon"';
        if (style) {
          html += ' ' + style;
        }
        html += ' md-svg-src="' + image + '"></md-icon>';
        break;
      default:
        html += '<img src="' + image + '">';
        break;
    }
    html += '</div></div>';

    return html;
  }
}
